<form [formGroup]="form">
  <div class="p-fluid">

    <kodit-field fieldLabel="Dodatni prilog/prilozi" fieldLabelFor="attachment">
      <p class="prilog-subtitle">
        * Maksimalna veličina svih priloga ne sme biti veća od 24 MB. Možete dodati najviše 2 PDF fajla. Fajlovi ne smeju biti veći od 15 MB
      </p>
      <kodit-file-upload
        (onUpload)="handleUpload($event)"
        [shouldAutoUpload]="true"
        [allowMultipleFiles]="true"
      ></kodit-file-upload>
    </kodit-field>

  </div>
</form>
